import React, { useState } from 'react';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import './FormsModal.css';
import MedicationForms from '../MedicationForms/MedicationForms'
import MedicationFormsMetaDoc from '../MedicationForms/MedicationFormsMetaDoc';
import LabRequestForms from '../LabRequestForms/LabRequestForms';
import LabRequestMetaDocForms from '../LabRequestForms/LabRequestMetaDocForms';


const FormsModalHIH = ({ formShort, header, memberBasicInfo, showMedicationModal, handleCloseMedicationModal, aiBupaServiceRecommendations, getAiBupaServiceRecommendations, handleFamilyMemberProfileClick }) => {

    const closeModal = async (e) => {
        handleCloseMedicationModal();
    };

    return (
        <>
            <Modal id="wpnb2" className='HealthManagement' centered show={showMedicationModal} onHide={handleCloseMedicationModal} size="xl" backdrop="static" keyboard={false} fullscreen={false}>
                <Modal.Header closeButton>
                    <h1 className='modal-title'>{header}</h1>
                </Modal.Header>
                <Modal.Body>
                    {formShort == 'med' && <MedicationForms closeModal={closeModal} aiBupaServiceRecommendations={aiBupaServiceRecommendations} memberBasicInfo={memberBasicInfo} getAiBupaServiceRecommendations={getAiBupaServiceRecommendations} handleFamilyMemberProfileClick={handleFamilyMemberProfileClick} />}

                    {formShort == 'medmetadoc' && <MedicationFormsMetaDoc closeModal={closeModal} memberBasicInfo={memberBasicInfo} aiBupaServiceRecommendations={aiBupaServiceRecommendations} getAiBupaServiceRecommendations={getAiBupaServiceRecommendations} handleFamilyMemberProfileClick={handleFamilyMemberProfileClick} />}

                    {formShort == 'hbl' && <LabRequestForms closeModal={closeModal} aiBupaServiceRecommendations={aiBupaServiceRecommendations} memberBasicInfo={memberBasicInfo} getAiBupaServiceRecommendations={getAiBupaServiceRecommendations} handleFamilyMemberProfileClick={handleFamilyMemberProfileClick} />}

                    {formShort == 'hblmetadoc' && <LabRequestMetaDocForms closeModal={closeModal} aiBupaServiceRecommendations={aiBupaServiceRecommendations} memberBasicInfo={memberBasicInfo} getAiBupaServiceRecommendations={getAiBupaServiceRecommendations} handleFamilyMemberProfileClick={handleFamilyMemberProfileClick} />}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default FormsModalHIH;